import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-16 px-4 bg-purple-900 text-white text-center" data-id="element-182">
      <div className="max-w-3xl mx-auto" data-id="element-183">
        <span className="inline-block px-4 py-1 rounded-full bg-purple-800 text-purple-200 text-sm font-bold uppercase tracking-wider mb-6 border border-purple-700" data-id="element-184">
          La solución definitiva
        </span>

        <h2 className="text-3xl md:text-5xl font-black mb-6 leading-tight" data-id="element-185">
          📘 MEGA PACK TERAPÉUTICO <br data-id="element-186" />
          <span className="text-purple-300" data-id="element-187">PARA PSICÓLOGAS™</span>
        </h2>

        <p className="text-lg md:text-xl text-purple-100 mb-8 max-w-2xl mx-auto" data-id="element-188">
          Un sistema completo de actividades terapéuticas organizadas para que
          nunca más tengas que empezar desde cero.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm font-bold mb-8" data-id="element-189">
          {['Todo listo', 'Todo probado', 'Todo ordenado', 'Todo usable'].map((item, i) => <div key={i} className="bg-purple-800/50 p-3 rounded-lg border border-purple-700 flex flex-col items-center justify-center gap-2" data-id="element-190">
                <CheckCircle2 className="w-6 h-6 text-green-400" data-id="element-191" />
                <span data-id="element-192">{item}</span>
              </div>)}
        </div>

        <p className="font-medium text-purple-200" data-id="element-193">
          Un pack creado por psicólogas, para psicólogas.
        </p>
      </div>
    </section>;
}